<template>
    <v-card class="py-3 px-4">
        <v-card-title class="headline px-0 pt-0 mb-3"
            >New Payment Method</v-card-title
        >
        <v-select
            class="mb-4"
            :items="paymentTypes"
            label="Payment Type"
            v-model="type"
            hide-details
        >
        </v-select>
        <v-layout column>
            <div v-if="type == 'Credit Card'">
                <v-text-field
                    class=""
                    label="Card Number"
                    ref="cardNumber"
                    :mask="creditCardMask"
                    v-model="cardNumber"
                    :rules="cardNumberRules"
                    append-icon="mdi-credit-card"
                ></v-text-field>
                <v-layout row class="mb-2">
                    <v-select
                        class="mr-1 "
                        ref="expirationMonth"
                        :items="getMonthOptions()"
                        label="Exp. Month"
                        v-model="expirationMonth"
                        :rules="expirationMonthRules"
                    ></v-select>
                    <v-select
                        :items="getYearOptions()"
                        ref="expirationYear"
                        v-model="expirationYear"
                        :rules="expirationYearRules"
                        label="Exp. year"
                    ></v-select>
                </v-layout>
                <v-layout row class="mb-2">
                    <v-text-field
                        style="margin-bottom: -27px"
                        label="Security Code"
                        ref="securityCode"
                        v-model="securityCode"
                        :rules="securityCodeRules"
                        :mask="securityCodeMask"
                    ></v-text-field>
                    <div style="height: 48px">
                        <img
                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-all.svg"
                            style="width: 77px;"
                        />
                        <img
                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-amex.svg"
                            style="width: 77px;"
                        />
                    </div>
                </v-layout>
            </div>
            <div v-else>
                <v-text-field
                    class=""
                    label="Name on Bank Account"
                    ref="nameOnAccount"
                    v-model="nameOnAccount"
                    :rules="nameOnAccountRules"
                ></v-text-field>
                <v-layout row class="mb-2">
                    <v-text-field
                        label="Routing Number"
                        ref="routingNumber"
                        :mask="routingNumberMask"
                        v-model="routingNumber"
                        :rules="routingNumberRules"
                    ></v-text-field>
                    <div style="height: 48px">
                        <img
                            src="https://utaw.blob.core.windows.net/images/check-routing.svg"
                            style="width: 96px;"
                        />
                    </div>
                </v-layout>
                <v-layout row class="mb-2">
                    <v-text-field
                        label="Account Number"
                        ref="accountNumber"
                        v-model="accountNumber"
                        :rules="accountNumberRules"
                    ></v-text-field>
                    <div style="height: 48px">
                        <img
                            src="https://utaw.blob.core.windows.net/images/check-account.svg"
                            style="width: 96px;"
                        />
                    </div>
                </v-layout>
                <v-text-field
                    label="Confirm Account Number"
                    ref="confirmAccountNumber"
                    v-model="confirmAccountNumber"
                    :rules="confirmAccountNumberRules"
                ></v-text-field>
            </div>
            <v-checkbox
                class="mb-3"
                hide-details
                label="Save For Future"
                color="success"
                v-model="saveForFuture"
            ></v-checkbox>
        </v-layout>
        <v-card-actions class="mx-0 pb-0 pt-3">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn :loading="processing" @click="save()" color="success">
                Save Payment Method
            </v-btn></v-card-actions
        >
    </v-card>
</template>
<script>
import cardValidator from "card-validator";
import moment from "moment";
import { isCharityCard } from "../../utils/helpers.js";

export default {
    props: {
        accountID: String,
        closeDialog: Function,
        onSave: Function,
        hideBankAccount: { default: false, type: Boolean },
    },
    data() {
        return {
            paymentTypes: ["Credit Card", "Bank Account"],
            type: "Credit Card",
            expirationMonth: "",
            expirationYear: "",
            cardNumber: "",
            securityCode: "",

            nameOnAccount: "",
            routingNumber: "",
            accountNumber: "",
            confirmAccountNumber: "",

            routingNumberMask: "#########",

            saveForFuture: true,

            processing: false,

            cardNumberRules: [
                (v) =>
                    this.type != "Credit Card" ||
                    !!v ||
                    "Card Number Is Required",
                (v) => (v && this.validateCard()) || "Invalid Card Number",
            ],
            expirationMonthRules: [
                (v) =>
                    this.type != "Credit Card" ||
                    !!v ||
                    "Expiration Month Is Required",
                (v) =>
                    (v && this.validateExpirationMonth()) ||
                    "Invalid Expiration Month",
            ],
            expirationYearRules: [
                (v) =>
                    this.type != "Credit Card" ||
                    !!v ||
                    "Expiration Year Is Required",
                (v) =>
                    (v && this.validateExpirationYear()) ||
                    "Invalid Expiration Year",
            ],
            securityCodeRules: [
                (v) =>
                    !v ||
                    (v && this.validateSecurityCode()) ||
                    "Invalid Security Code",
            ],

            nameOnAccountRules: [
                (v) =>
                    this.type == "Credit Card" ||
                    !!v ||
                    "Actual account name is required",
            ],
            routingNumberRules: [
                (v) =>
                    this.type == "Credit Card" ||
                    !!v ||
                    "Routing Number Is Required",
                (v) =>
                    (v && this.validateRoutingNumber()) ||
                    "Routing number is required",
            ],
            accountNumberRules: [
                (v) =>
                    this.type == "Credit Card" ||
                    !!v ||
                    "Account Number Is Required",
            ],
            confirmAccountNumberRules: [
                (v) =>
                    this.type == "Credit Card" ||
                    !!v ||
                    "Account Number Is Required",
                (v) =>
                    (v && this.accountNumber == v) || "Account does not match",
            ],
        };
    },
    async created() {
        if (this.hideBankAccount) {
            this.paymentTypes = ["Credit Card"];
        }
    },
    computed: {
        creditCardMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card &&
                numberValidation.card.type == "american-express"
                ? "#### ###### #####"
                : "#### #### #### ####";
        },
        securityCodeMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card && numberValidation.card.code.size == 4
                ? "####"
                : "###";
        },
    },
    methods: {
        getMonthOptions() {
            const months = [
                { value: "01", text: "1 January" },
                { value: "02", text: "2 February" },
                { value: "03", text: "3 March" },
                { value: "04", text: "4 April" },
                { value: "05", text: "5 May" },
                { value: "06", text: "6 June" },
                { value: "07", text: "7 July" },
                { value: "08", text: "8 August" },
                { value: "09", text: "9 September" },
                { value: "10", text: "10 October" },
                { value: "11", text: "11 November" },
                { value: "12", text: "12 December" },
            ];

            if (this.expirationYear != moment().format("YY")) return months;

            const currentMonth = new Date().getMonth();

            return months.filter((month) => +month.value >= currentMonth + 1);
        },
        getYearOptions() {
            const currentYear = moment().year();
            const currentMonth = moment().month() + 1;
            const yearOptions = [];

            for (let i = 0; i < 10; i++) {
                const year = moment()
                    .add(i, "years")
                    .year();

                if (this.expirationMonth <= currentMonth && i == 0) continue;

                yearOptions.push({
                    text: year,
                    value: year.toString().slice(-2),
                });
            }
            return yearOptions;
        },
        validateCard() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.isValid || isCharityCard(this.cardNumber);
        },
        validateExpirationMonth() {
            return cardValidator.expirationMonth(this.expirationMonth).isValid;
        },
        validateExpirationYear() {
            return cardValidator.expirationYear(this.expirationYear).isValid;
        },
        validateSecurityCode() {
            if (!this.securityCode) return true;

            const numberValidation = cardValidator.number(this.cardNumber);

            if (
                numberValidation &&
                numberValidation.card &&
                numberValidation.card.code
            ) {
                return cardValidator.cvv(
                    this.securityCode,
                    numberValidation.card.code.size,
                ).isValid;
            }

            return cardValidator.cvv(this.securityCode).isValid;
        },
        validateRoutingNumber() {
            return this.routingNumber.length == 9;
        },
        validate() {
            if (this.type == "Credit Card") {
                return [
                    this.$refs.cardNumber.validate(true),
                    this.$refs.expirationMonth.validate(true),
                    this.$refs.expirationYear.validate(true),
                    this.$refs.securityCode.validate(true),
                ].every(Boolean);
            }

            return [
                this.$refs.nameOnAccount.validate(true),
                this.$refs.routingNumber.validate(true),
                this.$refs.accountNumber.validate(true),
                this.$refs.confirmAccountNumber.validate(true),
            ].every(Boolean);
        },
        getCardNumber() {
            if (this.type == "Credit Card")
                return (this.cardNumber || "").replace(/\s/g, "");

            return this.routingNumber + "|" + this.accountNumber;
        },
        async save() {
            if (!this.validate()) return;

            this.processing = true;

            const data = {
                accountID: this.accountID,
                cardNumber: this.getCardNumber(),
                expiration: this.expirationMonth + this.expirationYear,
                cvv: this.securityCode,
                type: this.type,
                saveForFuture: this.saveForFuture,
                nameOnAccount: this.nameOnAccount,
            };

            try {
                const response = await this.$http.post(
                    "api/payments/saveNewPaymentMethod",
                    data,
                );

                this.onSave(response);
                this.closeDialog();

                this.processing = false;

                this.$notify({
                    text: "Payment Method Saved",
                    group: "notification",
                    type: "success",
                });

                this.reloadPage();
            } catch (e) {
                this.processing = false;

                return;
            }
        },
    },
};
</script>
<style></style>
